module.exports = __webpack_public_path__ + "static/media/zillowLogo.d9fa6332.png";